/* Hip is Het - favorieten (hartjes) in de webshop.
 * Eén bestand: pure logica (ook in node te testen) + opslag, sync met het account (app proxy) en UI.
 * Zie hipishet-app/docs/favorieten-sync.md (B en D). Zonder hih.fav.debug = "1" logt dit script niets. */
(function () {
  'use strict';

  // ---- logica (puur; ook in node te testen) ----
  var MAX = 100;
  var GID = 'gid://shopify/Product/';
  var GID_RE = /^gid:\/\/shopify\/Product\/[1-9][0-9]{0,19}$/;
  var NUM_RE = /^[1-9][0-9]{0,19}$/;
  var KLANT_RE = /^gid:\/\/shopify\/Customer\/[1-9][0-9]{0,19}$/;
  var MIN = 60000;
  var DAG = 86400000;

  function normalizeProductId(x) {
    if (typeof x === 'string') return GID_RE.test(x) ? x : NUM_RE.test(x) ? GID + x : null;
    if (typeof x === 'number' && Number.isSafeInteger(x) && x > 0) return GID + x;
    return null;
  }

  function cleanIds(x) {
    if (!Array.isArray(x)) return [];
    var uit = [], gezien = Object.create(null);
    for (var i = 0; i < x.length && uit.length < MAX; i++) {
      var id = normalizeProductId(x[i]);
      if (id && !gezien[id]) { gezien[id] = 1; uit.push(id); }
    }
    return uit;
  }

  function bevat(lijst, id) { return lijst.indexOf(id) >= 0; }

  // base = null telt als []
  function delta(local, base) {
    local = local || []; base = base || [];
    return {
      add: local.filter(function (id) { return !bevat(base, id); }),
      remove: base.filter(function (id) { return !bevat(local, id); })
    };
  }

  function applyDelta(list, d) {
    var weg = d.remove || [];
    return cleanIds((d.add || []).concat((list || []).filter(function (id) { return !bevat(weg, id); })));
  }

  function merge3(local, base, acc) { return applyDelta(acc, delta(local, base)); }

  function sameIds(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  function toggleId(list, id) {
    return bevat(list, id) ? list.filter(function (x) { return x !== id; }) : cleanIds([id].concat(list));
  }

  function leeg(d) { return !d.add.length && !d.remove.length; }

  // Openstaande wijzigingen van een accountrecord. Heeft het record een lijst "weg" (bewust ontsterd, nieuwste
  // eerst), dan telt alleen die als verwijdering: wat de limiet van 100 eraf drukt sturen we niet mee (kritiek #23).
  // Met tegen = sent (afterWrite) zijn het de wijzigingen tijdens de vlucht, ook het ontsteren van een id dat nog
  // onderweg was (nog niet in base).
  function pendingDelta(record, tegen) {
    var d = delta(record.local, tegen === undefined ? record.base : tegen);
    if (Array.isArray(record.weg)) d.remove = d.remove.filter(function (id) { return bevat(record.weg, id); });
    return d;
  }

  function hasPending(record) { return record.base === null || !leeg(pendingDelta(record)); }

  // "weg" bijwerken na een lezing of schrijfactie (acc = de nieuwe accountlijst, d = de toegepaste delta). Een id
  // blijft staan zolang het niet in local staat, tenzij het account het heeft zonder dat wij het net verwijderden:
  // dan is het elders opnieuw bewaard (of viel het door de limiet weg) en is onze oude verwijdering voorbij.
  function houdWeg(record, acc, d) {
    if (!Array.isArray(record.weg)) return;
    record.weg = record.weg.filter(function (id) { return !bevat(record.local, id) && (!bevat(acc, id) || bevat(d.remove, id)); });
  }

  function nieuwRecord(owner) {
    return { v: 1, owner: owner, base: null, local: [], h: {}, at: 0, fout: null, actief: true, laatst: 0, weg: [] };
  }

  // B2.1: de klant is bekend. Een record van een andere klant (ook met openstaande wijzigingen) vervalt.
  // nu (optioneel) = tijd van de samenvoeging; telt als nieuwste openstaande wijziging (kritiek #24).
  function establishOwner(state, customerGid, nu) {
    var r = state.record;
    if (!r || r.owner !== customerGid) r = state.record = nieuwRecord(customerGid);
    r.actief = true;
    if (state.guest.length) {
      r.local = cleanIds(state.guest.concat(r.local));
      var h = state.h || {};
      r.h = r.h || {};
      state.guest.forEach(function (id) { if (h[id] && !r.h[id]) r.h[id] = h[id]; });
      state.guest = []; state.h = {}; state.mist = {};
      if (nu) r.laatst = nu;
    }
    return state;
  }

  // B2.2: elk volledig leesresultaat (een gedeeltelijke lezing nooit, kritiek #4). Base en local altijd samen.
  function applyRead(record, accountIds) {
    var acc = cleanIds(accountIds);
    var p = pendingDelta(record);
    record.base = acc;
    record.local = applyDelta(acc, p);
    houdWeg(record, acc, p);
    return record;
  }

  // B2.3: na een geslaagde sync; sent = local toen de sync begon. Daarna: hasPending -> nog een sync.
  function afterWrite(record, sent, result) {
    var acc = cleanIds(result);
    var d2 = pendingDelta(record, sent);
    record.base = acc;
    record.local = applyDelta(acc, d2);
    houdWeg(record, acc, d2);
    return record;
  }

  // B2.4: uitgelogd. Standaard (G1) verdwijnen de favorieten van het apparaat; openstaande wijzigingen
  // blijven slapend bewaard voor dezelfde klant.
  function onLogout(state, keepOnLogout) {
    var r = state.record;
    if (!r) return state;
    if (keepOnLogout) {
      state.guest = cleanIds(state.guest.concat(r.local));
      state.h = Object.assign({}, r.h || {}, state.h || {});
      state.record = null;
    } else if (!hasPending(r)) {
      state.record = null;
    } else {
      r.actief = false;
    }
    return state;
  }

  function displayIds(state) {
    return state.record && state.record.actief !== false ? state.record.local : state.guest;
  }

  // Hartje aan/uit op het accountrecord. Elke bewuste verwijdering komt vooraan in "weg", ook van een id dat nog
  // niet in base staat (de toevoeging kan onderweg zijn, in dit of een ander tabblad). nu (optioneel) = tijd van
  // deze wijziging. Geeft true als het product nu favoriet is.
  function toggleRecord(record, id, nu) {
    var had = bevat(record.local, id);
    record.local = toggleId(record.local, id);
    record.weg = (record.weg || []).filter(function (x) { return x !== id; });
    if (had) record.weg.unshift(id);
    if (nu) record.laatst = nu;
    return !had;
  }

  // Wachttijd na de n-de mislukte poging. "niet_live" (proxy geeft HTML) = rustig, hooguit elke 10 min.
  function volgendePoging(n, soort) {
    if (soort === 'niet_live') return 10 * MIN;
    return Math.min(30 * MIN, MIN * Math.pow(2, Math.max(0, n - 1)));
  }

  // Openstaande wijzigingen vervallen als ook de nieuwste ervan ouder is dan 30 dagen (kritiek #24); zolang de klant
  // op dit apparaat blijft wijzigen, blijft alles staan. Geeft true als er iets verviel.
  function verloopPending(record, nu) {
    if (!record || !record.laatst || nu - record.laatst <= 30 * DAG || !hasPending(record)) return false;
    record.local = record.base ? record.base.slice() : [];
    record.weg = [];
    record.laatst = 0;
    return true;
  }

  // Netjes houden vóór opslaan: h/mist alleen voor ids die nog in de lijst staan, "weg" alleen voor ids die niet
  // in local staan (hooguit 100, de nieuwste), "laatst" bijwerken.
  function beperk(state, nu) {
    state.h = alleen(state.h, state.guest);
    state.mist = alleen(state.mist, state.guest);
    var r = state.record;
    if (r) {
      r.h = alleen(r.h, r.local);
      r.weg = cleanIds((r.weg || []).filter(function (id) { return !bevat(r.local, id); }));
      if (!hasPending(r)) r.laatst = 0;
      else if (!r.laatst) r.laatst = nu;
    }
    return state;
  }

  function alleen(map, ids) {
    var uit = {};
    if (map && typeof map === 'object') ids.forEach(function (id) { if (Object.prototype.hasOwnProperty.call(map, id)) uit[id] = map[id]; });
    return uit;
  }

  // 14-dagenregel voor de gastenlijst (B7): eerst markeren, na 14 dagen nog steeds weg = verwijderen.
  function pruneGuest(state, missing, nu) {
    missing.forEach(function (id) {
      if (!bevat(state.guest, id)) return;
      if (!state.mist[id]) state.mist[id] = nu;
      else if (nu - state.mist[id] >= 14 * DAG) {
        state.guest = state.guest.filter(function (x) { return x !== id; });
        delete state.mist[id]; delete state.h[id];
      }
    });
    return state;
  }

  var logica = {
    MAX: MAX, normalizeProductId: normalizeProductId, cleanIds: cleanIds, delta: delta, applyDelta: applyDelta,
    merge3: merge3, sameIds: sameIds, toggleId: toggleId, pendingDelta: pendingDelta, hasPending: hasPending,
    nieuwRecord: nieuwRecord, establishOwner: establishOwner, applyRead: applyRead, afterWrite: afterWrite,
    onLogout: onLogout, displayIds: displayIds, toggleRecord: toggleRecord, volgendePoging: volgendePoging,
    verloopPending: verloopPending, beperk: beperk, pruneGuest: pruneGuest
  };
  // Alleen buiten de browser exporteren (een gelekte globale "module" van een app mag dit niet uitschakelen).
  if (typeof window === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logica;
    return;
  }
  if (window.HihFavorieten) return; // niet dubbel starten

  // ---- configuratie ----
  var doc = document, cfg;
  try { cfg = JSON.parse(doc.getElementById('hih-fav-config').textContent); } catch (e) { return; }
  if (!cfg || cfg.v !== 1) return;
  var klant = typeof cfg.klant === 'string' && KLANT_RE.test(cfg.klant) ? cfg.klant : null;
  var proxy = typeof cfg.proxy === 'string' && /^\/[^/]/.test(cfg.proxy) ? cfg.proxy : null;
  var teksten = cfg.teksten || {};
  var K_GAST = 'hih.fav.gast', K_KLANT = 'hih.fav.klant', K_ZICHT = 'hih.fav.zicht';

  // ---- opslag (localStorage; valt terug op geheugen, gooit nooit) ----
  var opslag = true, mem = {};
  function lees(k) {
    if (opslag) { try { return localStorage.getItem(k); } catch (e) { opslag = false; } }
    return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null;
  }
  function schrijf(k, v) {
    if (v === null) delete mem[k]; else mem[k] = v;
    if (!opslag) return;
    try {
      if (v === null) { if (localStorage.getItem(k) !== null) localStorage.removeItem(k); }
      else if (localStorage.getItem(k) !== v) localStorage.setItem(k, v);
    } catch (e) { opslag = false; }
  }
  function json(s) { try { return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  var DEBUG = lees('hih.fav.debug') === '1';
  function log() { if (DEBUG && window.console) console.info.apply(console, ['[favorieten]'].concat([].slice.call(arguments))); }
  function getal(x) { return typeof x === 'number' && isFinite(x) && x > 0 ? x : 0; }

  function laad() {
    var g = json(lees(K_GAST)), r = json(lees(K_KLANT));
    var st = { guest: [], h: {}, mist: {}, record: null };
    if (g && g.v === 1) { st.guest = cleanIds(g.ids); st.h = alleen(g.h, st.guest); st.mist = alleen(g.mist, st.guest); }
    if (r && r.v === 1 && typeof r.owner === 'string') {
      st.record = {
        v: 1, owner: r.owner, base: Array.isArray(r.base) ? cleanIds(r.base) : null, local: cleanIds(r.local),
        h: alleen(r.h, cleanIds(r.local)), at: getal(r.at), actief: r.actief !== false, laatst: getal(r.laatst),
        fout: r.fout && getal(r.fout.n) ? { n: r.fout.n, volgende: getal(r.fout.volgende) } : null, weg: cleanIds(r.weg)
      };
    }
    return st;
  }

  function actiefRecord(st) {
    var r = st.record;
    return klant && r && r.owner === klant && r.actief !== false ? r : null;
  }

  // Het tabblad hoort nog bij wat er is opgeslagen? (kritiek #8: anders niet meer opslaan of syncen)
  function eigenaarKlopt(st) { return klant ? !!actiefRecord(st) : !(st.record && st.record.actief !== false); }

  // vluchtig: gedeeltelijke Liquid-lijst, alleen voor weergave zolang er geen base is (kritiek #4).
  // naLezen: in die toestand ontsterde ids; die worden na de eerste volledige lezing echt verwijderd.
  // bootVol: de Liquid-lezing van deze pagina is toegepast (anders wacht de favorietenpagina op het netwerk).
  var staat, verweesd = false, vluchtig = null, naLezen = [], bootVol = false;

  function weergave(st) {
    var r = actiefRecord(st);
    if (!r) return st.guest;
    return vluchtig && r.base === null ? cleanIds(r.local.concat(vluchtig)) : r.local;
  }

  function bewaar(st) {
    beperk(st, Date.now());
    schrijf(K_GAST, st.guest.length ? JSON.stringify({ v: 1, ids: st.guest, h: st.h, mist: st.mist }) : null);
    schrijf(K_KLANT, st.record ? JSON.stringify(st.record) : null);
    var ids = weergave(st), r = actiefRecord(st);
    // Gasten zonder favorieten schrijven niets weg (kritiek #28).
    schrijf(K_ZICHT, ids.length || r ? JSON.stringify({ o: r ? klant : null, ids: ids.map(nummer) }) : null);
  }

  // Lees de verse opslag, pas de overgang toe en schrijf meteen terug (kritiek #19: geen verloren update
  // tussen tabbladen). Een verweesd tabblad werkt alleen nog in zijn eigen geheugen.
  function muteer(fn) {
    if (!verweesd) {
      var st = laad();
      if (eigenaarKlopt(st)) { fn(st); bewaar(st); staat = st; render(); return true; }
      wees();
    }
    fn(staat); render();
    return false;
  }
  function wees() { if (!verweesd) { verweesd = true; log('ander account in een ander tabblad; dit tabblad synct niet meer'); } }

  function nummer(gid) { return gid.slice(GID.length); }

  // ---- weergave ----
  function qsa(sel, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(sel)); }
  function aantalTekst(n) {
    var t = String((n === 1 ? teksten.aantalEen : teksten.aantalMeer) || '{{ count }}');
    return /\{\{\s*count\s*\}\}/.test(t) ? t.replace(/\{\{\s*count\s*\}\}/g, n) : n + ' ' + t.trim();
  }

  function render() {
    var ids = weergave(staat), num = ids.map(nummer), aan = Object.create(null);
    num.forEach(function (i) { aan[i] = 1; });
    var s = doc.getElementById('hih-fav-stijl');
    if (!s) { s = doc.createElement('style'); s.id = 'hih-fav-stijl'; doc.head.appendChild(s); }
    var css = num.length ? num.map(function (i) { return '.hih-fav[data-hih-fav="' + i + '"]'; }).join(',') + '{--hih-fav-kleur:#F400A1;--hih-fav-vul:#F400A1}' : '';
    if (s.textContent !== css) s.textContent = css;
    qsa('[data-hih-fav]').forEach(function (el) { markeer(el, aan); });
    var n = ids.length;
    qsa('[data-hih-fav-aantal]').forEach(function (el) { el.textContent = n; el.classList.toggle('hih-fav-nul', !n); });
    qsa('[data-hih-fav-tekst]').forEach(function (el) { el.textContent = n ? '(' + n + ')' : ''; });
    qsa('[data-hih-fav-link]').forEach(function (el) { el.setAttribute('aria-label', (teksten.titel || '') + ', ' + aantalTekst(n)); });
    try { doc.dispatchEvent(new CustomEvent('hih:favorieten', { detail: { count: n } })); } catch (e) { /* oude browser */ }
  }

  function markeer(el, aan) {
    var p = aan[el.getAttribute('data-hih-fav')] ? 'true' : 'false';
    if (el.getAttribute('aria-pressed') !== p) el.setAttribute('aria-pressed', p);
    if (!el.hasAttribute('data-hih-klaar')) el.setAttribute('data-hih-klaar', '');
  }

  // Nieuwe hartjes (meer laden, filters, aanbevelingen, quickshop, marquee): alleen aria-pressed zetten.
  var moBezig = false;
  function nieuweKnoppen() {
    var els = qsa('[data-hih-fav]:not([data-hih-klaar])');
    if (!els.length) return;
    var aan = Object.create(null);
    weergave(staat).forEach(function (id) { aan[nummer(id)] = 1; });
    els.forEach(function (el) { markeer(el, aan); });
  }

  var live;
  function meld(tekst) {
    if (!live) {
      live = doc.createElement('div');
      live.className = 'hih-fav-sr';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      doc.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = tekst || ''; }, 50);
  }

  // ---- aan/uit ----
  function toggle(id, handle) {
    var gid = normalizeProductId(typeof id === 'number' ? id : String(id == null ? '' : id));
    if (!gid) return false;
    var nu = false;
    handle = typeof handle === 'string' && /^[^/?#\s]{1,255}$/.test(handle) ? handle : '';
    muteer(function (st) {
      var r = actiefRecord(st);
      if (r && vluchtig && r.base === null && bevat(vluchtig, gid) && !bevat(r.local, gid)) {
        vluchtig = vluchtig.filter(function (x) { return x !== gid; });
        if (!bevat(naLezen, gid)) naLezen.push(gid);
      } else if (r) {
        naLezen = naLezen.filter(function (x) { return x !== gid; });
        nu = toggleRecord(r, gid, Date.now());
        if (nu && handle) r.h[gid] = handle;
      } else {
        nu = !bevat(st.guest, gid);
        st.guest = toggleId(st.guest, gid);
        if (nu && handle) st.h[gid] = handle;
        delete st.mist[gid];
      }
    });
    meld(nu ? teksten.toegevoegd : teksten.verwijderd);
    if (klant) planSync(300);
    pagina.gewijzigd(gid, nu, handle);
    return nu;
  }

  // ---- netwerk ----
  function vraag(methode, body) {
    var url = proxy + (methode === 'GET' ? (proxy.indexOf('?') < 0 ? '?' : '&') + 'eigenaar=' + encodeURIComponent(klant) : '');
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var klok = setTimeout(function () { if (ctrl) ctrl.abort(); }, 12000);
    var kop = { Accept: 'application/json', 'X-Hipishet-Favorieten': '1' };
    var opties = { method: methode, credentials: 'same-origin', cache: 'no-store', headers: kop };
    if (ctrl) opties.signal = ctrl.signal;
    if (body) { kop['Content-Type'] = 'application/json'; opties.body = body; opties.keepalive = true; }
    function klaar(x) { clearTimeout(klok); return x; }
    try {
      return fetch(url, opties).then(function (res) {
        var ct = (res.headers.get('content-type') || '').toLowerCase();
        if (ct.indexOf('application/json') < 0) return klaar({ ok: false, status: res.status, soort: 'niet_live' });
        return res.json().then(function (j) {
          if (res.ok && j && typeof j === 'object' && Array.isArray(j.ids)) {
            return klaar({ ok: true, ids: cleanIds(j.ids), klant: j.klant, verwijderd: cleanIds(j.verwijderd) });
          }
          var wacht = parseInt(res.headers.get('retry-after'), 10);
          return klaar({ ok: false, status: res.status, soort: 'http', code: j && j.fout && j.fout.code, wacht: wacht > 0 ? wacht : 0 });
        }, function () { return klaar({ ok: false, status: res.status, soort: 'niet_live' }); });
      }).catch(function () { return klaar({ ok: false, status: 0, soort: 'netwerk' }); });
    } catch (e) {
      return Promise.resolve(klaar({ ok: false, status: 0, soort: 'netwerk' }));
    }
  }

  // ---- sync (B3/B4): hooguit één tegelijk per tabblad ----
  var bezig = false, nogEens = false, klok = 0, leesNodig = false, wachtenden = [];

  function kanSyncen() { return !!(klant && proxy && !verweesd); }
  function planSync(ms) {
    if (!kanSyncen()) return los();
    clearTimeout(klok);
    klok = setTimeout(sync, ms || 0);
  }
  function los() { var w = wachtenden; wachtenden = []; w.forEach(function (f) { f(); }); }

  function sync() {
    clearTimeout(klok); klok = 0;
    if (!kanSyncen()) return los();
    if (bezig) { nogEens = true; return; }
    var st = laad();
    if (!eigenaarKlopt(st)) { wees(); return los(); }
    var r = st.record, nu = Date.now();
    if (r.fout && r.fout.volgende > nu) { // terugtrekken: geen netwerk, wel later opnieuw
      klok = setTimeout(sync, Math.min(r.fout.volgende - nu + 100, 31 * MIN));
      return los();
    }
    var sent = r.local.slice(), d = pendingDelta(r);
    var post = !leeg(d);
    if (!post && !leesNodig && r.base !== null) return los();
    bezig = true; nogEens = false;
    var gestart = nu;
    vraag(post ? 'POST' : 'GET', post ? JSON.stringify({ add: d.add, remove: d.remove, eigenaar: klant }) : null)
      .then(function (res) { return verwerk(res, sent, gestart); })
      .then(function () { bezig = false; if (nogEens) planSync(0); else los(); }, function (e) {
        bezig = false; log('sync', e); los();
      });
  }

  function verwerk(res, sent, gestart) {
    if (res.ok && res.klant !== klant) { wees(); return; } // antwoord hoort bij een ander account
    if (res.ok) {
      leesNodig = false;
      var vol = muteer(function (st) {
        var r = actiefRecord(st);
        if (!r) return;
        verwijder(st, res.verwijderd);
        // Een ander tabblad las het account al na onze start: dat is nieuwer, niet terugzetten.
        if (!(r.at && r.at > gestart)) afterWrite(r, sent, res.ids);
        naLezen.forEach(function (id) { if (bevat(r.local, id)) toggleRecord(r, id, Date.now()); });
        naLezen = []; vluchtig = null;
        r.at = Date.now(); r.fout = null;
        if (hasPending(r)) nogEens = true;
      });
      if (vol) pagina.volledig();
      return;
    }
    if (res.status === 409 && res.code === 'andere_klant') { wees(); return; }
    if (res.status === 400) return herstel400();
    terugtrekken(res);
  }

  // Op 400 klopt de openstaande wijziging niet: één keer lezen en base = local = account (kritiek #9).
  function herstel400() {
    log('400: openstaande wijziging vervalt');
    return vraag('GET', null).then(function (res) {
      if (!res.ok) return terugtrekken(res);
      if (res.klant !== klant) return wees();
      muteer(function (st) {
        var r = actiefRecord(st);
        if (!r) return;
        r.base = res.ids.slice(); r.local = res.ids.slice(); r.weg = []; r.at = Date.now(); r.fout = null;
        naLezen = []; vluchtig = null;
      });
      pagina.volledig();
    });
  }

  function terugtrekken(res) {
    log('sync mislukt', res.status, res.code || res.soort);
    muteer(function (st) {
      var r = actiefRecord(st);
      if (!r) return;
      var n = (r.fout ? r.fout.n : 0) + 1;
      r.fout = { n: n, volgende: Date.now() + Math.max(volgendePoging(n, res.soort), (res.wacht || 0) * 1000) };
    });
    var f = staat.record && staat.record.fout;
    if (f) { clearTimeout(klok); klok = setTimeout(sync, Math.min(Math.max(f.volgende - Date.now(), 0) + 100, 31 * MIN)); }
    pagina.volledig(); // geen verse lezing: de favorietenpagina gaat uit van de opgeslagen stand
  }

  // Door de server opgeruimde (definitief verwijderde) producten ook uit gastenlijst en record halen.
  function verwijder(st, ids) {
    if (!ids || !ids.length) return;
    st.guest = st.guest.filter(function (id) { return !bevat(ids, id); });
    var r = st.record;
    if (r) {
      r.local = r.local.filter(function (id) { return !bevat(ids, id); });
      if (r.base) r.base = r.base.filter(function (id) { return !bevat(ids, id); });
    }
  }

  function refresh() {
    return new Promise(function (klaar) {
      if (!kanSyncen()) return klaar();
      wachtenden.push(klaar);
      leesNodig = true;
      if (bezig) nogEens = true; else planSync(0);
    });
  }

  // ---- start ----
  // HTML uit de cache (terug-knop, prefetch) kan een verouderde boot-read bevatten (kritiek #7).
  function uitCache() {
    try {
      var n = performance.getEntriesByType('navigation')[0];
      return !!n && (n.type === 'back_forward' || (n.transferSize === 0 && n.decodedBodySize > 0));
    } catch (e) { return false; }
  }

  function bootLees(r, nu) {
    var acc = cfg.account;
    if (!acc || typeof acc !== 'object') { leesNodig = true; return; }
    if (acc.volledig === true) {
      var ids = null;
      try { var p = JSON.parse(acc.ruw); if (Array.isArray(p)) ids = cleanIds(p); } catch (e) { ids = null; }
      if (!ids) { leesNodig = true; return; }
      var t = getal(cfg.t) * 1000;
      var oud = uitCache() || (t && r.at && t + 2 * MIN < r.at);
      var vers = r.at && nu - r.at < MIN && r.base && !sameIds(ids, r.base);
      if (r.base !== null && (oud || vers)) { leesNodig = true; return; }
      applyRead(r, ids);
      r.at = nu;
      bootVol = true;
      return;
    }
    // Gedeeltelijk (Liquid, max 50): nooit applyRead (kritiek #4). Alleen tonen zolang er geen base is.
    if (r.base === null) vluchtig = cleanIds(acc.ids);
    leesNodig = true;
  }

  function start() {
    var st = laad(), nu = Date.now();
    if (klant) {
      if (st.record && st.record.owner === klant) verloopPending(st.record, nu);
      establishOwner(st, klant, nu);
      bootLees(st.record, nu);
    } else if (st.record) {
      if (st.record.actief !== false) onLogout(st, cfg.uitloggenBewaart === true);
      else if (verloopPending(st.record, nu)) st.record = null;
    }
    bewaar(st);
    staat = st;
    render();

    window.addEventListener('click', klik, true);
    if (typeof MutationObserver === 'function' && doc.body) {
      new MutationObserver(function () {
        if (moBezig) return;
        moBezig = true;
        (window.requestAnimationFrame || setTimeout)(function () {
          setTimeout(function () { moBezig = false; nieuweKnoppen(); }, 100);
        });
      }).observe(doc.body, { childList: true, subtree: true });
    }
    window.addEventListener('storage', function (e) {
      if (e.key && e.key.indexOf('hih.fav.') !== 0) return;
      herlaad();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { herlaad(); misschienLezen(); } });
    doc.addEventListener('visibilitychange', function () {
      if (doc.visibilityState === 'visible') misschienLezen();
      else if (klok && !bezig) sync(); // wegklikken: openstaande wijziging nu versturen (keepalive)
    });
    window.addEventListener('pagehide', function () { if (klok && !bezig) sync(); });

    pagina.start(bootVol || !proxy);
    if (klant && (leesNodig || hasPending(staat.record))) planSync(0);
  }

  // Andere tabbladen of bfcache: toestand opnieuw uit de opslag halen, zonder netwerk.
  function herlaad() {
    if (verweesd) return;
    var st = laad();
    if (!eigenaarKlopt(st)) return wees();
    staat = st;
    render();
  }

  function misschienLezen() {
    var r = staat && actiefRecord(staat);
    if (r && Date.now() - (r.at || 0) > 5 * MIN) { leesNodig = true; planSync(0); }
  }

  function klik(e) {
    var t = e.target, knop = t && t.closest ? t.closest('[data-hih-fav]') : null;
    if (!knop) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    toggle(knop.getAttribute('data-hih-fav'), knop.getAttribute('data-hih-handle'));
    knop.classList.remove('hih-fav--tik');
    void knop.offsetWidth;
    knop.classList.add('hih-fav--tik');
    setTimeout(function () { knop.classList.remove('hih-fav--tik'); }, 300);
  }

  // ---- favorietenpagina (alleen als [data-hih-fav-pagina] bestaat) ----
  var pagina = (function () {
    var PER_PAGINA = 24; // gelijk aan "paginate ... by 24" in sections/hip-favorieten.liquid
    var root, raster, leegEl, foutEl, meer, sentinel, bron, rij = [], getoond = 0, laden = 0, geprobeerd = {}, mag = false;

    function kaartId(li) {
      var k = li.querySelector('[data-hih-fav]');
      return k ? normalizeProductId(k.getAttribute('data-hih-fav')) : null;
    }
    function kaarten() { return qsa(':scope > li', raster); }
    function opRaster(id) { return kaarten().filter(function (li) { return kaartId(li) === id; })[0] || null; }
    // Verbergen in plaats van weghalen: komt het product terug in de lijst (verse lezing, opnieuw bewaard), dan
    // staat de kaart er meteen weer, en "Toon meer" weet hoeveel kaarten er van de serverpagina's af zijn.
    function zet(li, aan) {
      if (aan) { li.removeAttribute('data-hih-weg'); li.hidden = false; } else { li.setAttribute('data-hih-weg', ''); li.hidden = true; }
    }
    function werkLeegBij() {
      if (!leegEl) return;
      var zichtbaar = kaarten().some(function (li) { return !li.hasAttribute('data-hih-weg'); });
      leegEl.hidden = zichtbaar || !!laden || !!rij.length || !!(meer && meer.isConnected);
    }

    function naInvoegen() {
      ['listScrollable', 'ratings', 'productcardVariants', 'listCollectionSlider'].forEach(function (naam) {
        try { window.dispatchEvent(new CustomEvent(naam)); } catch (e) { /* thema-script ontbreekt */ }
      });
      try { if (window.quickShop && window.quickShop.init) window.quickShop.init(); } catch (e) { log('quickShop', e); }
      try { if (window.ajaxCart && window.ajaxCart.init) window.ajaxCart.init(); } catch (e) { log('ajaxCart', e); }
      nieuweKnoppen();
    }

    function parse(html, sel) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      return d.querySelector(sel);
    }

    function haalKaart(gid, handle) {
      if (!handle) return Promise.resolve({ mist: true });
      var url = (cfg.root || '/') + 'products/' + encodeURIComponent(handle) + '?section_id=product-item';
      return fetch(url, { credentials: 'same-origin' }).then(function (res) {
        if (res.status === 404) return { mist: true };
        if (!res.ok) return { fout: true };
        return res.text().then(function (html) {
          var s = parse(html, '#shopify-section-product-item'), li = s && s.firstElementChild;
          return li && li.tagName === 'LI' ? { li: doc.importNode(li, true) } : { fout: true };
        });
      }).catch(function () { return { fout: true }; });
    }

    // Haal kaarten op (max 4 tegelijk) en geef ze in lijstvolgorde terug.
    function haalReeks(ids, handles) {
      var uit = new Array(ids.length), i = 0;
      function werker() {
        if (i >= ids.length) return Promise.resolve();
        var k = i++;
        return haalKaart(ids[k], handles[ids[k]]).then(function (x) { uit[k] = x; return werker(); });
      }
      var w = [];
      for (var n = 0; n < Math.min(4, ids.length); n++) w.push(werker());
      return Promise.all(w).then(function () { return uit; });
    }

    // Kaart op zijn plek in de lijst zetten: vóór de eerste kaart die later in de lijst staat.
    function plaats(li, id) {
      var lijst = weergave(staat), i = lijst.indexOf(id), voor = null;
      kaarten().some(function (k) { if (lijst.indexOf(kaartId(k)) > i) { voor = k; return true; } return false; });
      raster.insertBefore(li, voor);
    }

    // Losse kaarten ophalen (per id hooguit één keer per paginabezoek) en in lijstvolgorde invoegen.
    function voegToe(ids, handles) {
      ids = ids.filter(function (id) { return !geprobeerd[id]; });
      if (!ids.length) return;
      ids.forEach(function (id) { geprobeerd[id] = 1; });
      laden++;
      haalReeks(ids, handles).then(function (res) {
        laden--;
        var erbij = false;
        res.forEach(function (x, k) {
          if (x.li && !opRaster(ids[k]) && bevat(weergave(staat), ids[k])) { plaats(x.li, ids[k]); erbij = true; }
        });
        if (erbij) naInvoegen();
        werkLeegBij();
      });
    }

    // Gast: kaarten in blokken van 24 laden; volgende blok zodra de sentinel in beeld komt.
    function volgendBlok() {
      if (laden || !rij.length) return;
      var ids = rij.splice(0, 24), h = staat.h;
      laden++;
      haalReeks(ids, h).then(function (res) {
        laden--;
        var frag = doc.createDocumentFragment(), weg = [], gevonden = [];
        res.forEach(function (x, k) {
          if (x.li) {
            if (!bevat(weergave(staat), ids[k])) return; // intussen ontsterd
            frag.appendChild(x.li); gevonden.push(ids[k]); getoond++;
          } else if (x.mist) weg.push(ids[k]);
        });
        if (frag.childNodes.length) { raster.appendChild(frag); naInvoegen(); }
        if (weg.length || gevonden.length) {
          muteer(function (st) {
            if (actiefRecord(st)) return;
            gevonden.forEach(function (id) { delete st.mist[id]; });
            pruneGuest(st, weg, Date.now());
          });
        }
        if (foutEl) foutEl.hidden = !(getoond === 0 && !rij.length && res.some(function (x) { return x.fout; }));
        werkLeegBij();
        if (rij.length) kijkSentinel();
      });
    }

    function kijkSentinel() {
      if (!sentinel) {
        sentinel = doc.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        raster.parentNode.insertBefore(sentinel, raster.nextSibling);
      }
      if (typeof IntersectionObserver !== 'function') return volgendBlok();
      var io = new IntersectionObserver(function (items) {
        if (items.some(function (x) { return x.isIntersecting; })) { io.disconnect(); volgendBlok(); }
      }, { rootMargin: '600px 0px' });
      io.observe(sentinel);
    }

    // De te laden serverpagina's. Elke weggehaalde kaart schuift de lijst op de server één plek naar voren, dus de
    // eerste kaarten van pagina N+1 staan dan al op pagina N: haal zoveel pagina's extra terug op.
    function paginaUrls(href, sectie) {
      var terug = Math.ceil(qsa(':scope > li[data-hih-weg]', raster).length / PER_PAGINA);
      try {
        var u = new URL(href, location.href), p = parseInt(u.searchParams.get('page'), 10) || 2, uit = [];
        u.searchParams.set('section_id', sectie);
        for (var n = Math.max(1, p - terug); n <= p; n++) { u.searchParams.set('page', n); uit.push(u.pathname + u.search); }
        return uit;
      } catch (e) {
        return [href + (href.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectie)];
      }
    }

    // Ingelogd: volgende pagina (24 per pagina) van deze sectie ophalen en alles achteraan toevoegen wat nog niet op
    // het raster staat, in lijstvolgorde.
    function laadMeer(e) {
      if (e && e.preventDefault) e.preventDefault();
      if (!meer || meer.getAttribute('data-bezig')) return;
      var href = meer.getAttribute('href'), sectie = root.getAttribute('data-sectie');
      if (!href || !sectie) return;
      meer.setAttribute('data-bezig', '1');
      laden++;
      Promise.all(paginaUrls(href, sectie).map(function (u) {
        return fetch(u, { credentials: 'same-origin' }).then(function (res) { return res.ok ? res.text() : null; }, function () { return null; });
      })).then(function (htmls) {
        laden--;
        meer.removeAttribute('data-bezig');
        var delen = htmls.map(function (h) { return h ? parse(h, '[data-hih-fav-pagina]') : null; }), laatste = delen[delen.length - 1];
        if (!laatste) return werkLeegBij();
        var frag = doc.createDocumentFragment(), gezien = {}, lijst = weergave(staat), vol = !!actiefRecord(staat) && staat.record.base !== null;
        delen.forEach(function (deel) {
          if (deel) qsa('[data-hih-fav-raster] > li', deel).forEach(function (li) {
            var id = kaartId(li);
            if (!id || gezien[id] || opRaster(id) || (vol && !bevat(lijst, id))) return;
            gezien[id] = 1;
            frag.appendChild(doc.importNode(li, true));
          });
        });
        if (frag.childNodes.length) { raster.appendChild(frag); naInvoegen(); }
        var volgende = laatste.querySelector('[data-hih-fav-meer]');
        if (volgende && volgende.getAttribute('href')) { meer.setAttribute('href', volgende.getAttribute('href')); kijkMeer(); }
        else {
          if (meer.parentNode) meer.parentNode.removeChild(meer);
          meer = null;
          if (mag) volledig(); // alles geladen: nu mogen ook gaten aan het eind worden aangevuld
        }
        werkLeegBij();
      }).catch(function (e) { log('meer', e); werkLeegBij(); });
    }

    function kijkMeer() {
      if (!meer || typeof IntersectionObserver !== 'function') return;
      var io = new IntersectionObserver(function (items) {
        if (items.some(function (x) { return x.isIntersecting; })) { io.disconnect(); laadMeer(); }
      }, { rootMargin: '400px 0px' });
      io.observe(meer);
    }

    // Ingelogd, met een volledige stand: kaarten die niet in de lijst staan verbergen, die er (weer) in staan tonen,
    // en ontbrekende kaarten met een bekende handle ophalen: openstaande toevoegingen, en gaten in wat al geladen
    // is. Een product dat op een ander apparaat is bewaard (handle hier onbekend) verschijnt pas na herladen.
    function volledig() {
      if (!root || bron !== 'server') return;
      var r = actiefRecord(staat);
      if (!r || r.base === null) return;
      var lijst = weergave(staat), tot = -1, nieuw = pendingDelta(r).add;
      kaarten().forEach(function (li) {
        var id = kaartId(li), i = id ? lijst.indexOf(id) : -1;
        if (id) zet(li, i >= 0);
        if (i > tot) tot = i;
      });
      voegToe(lijst.filter(function (id, i) { return r.h[id] && !opRaster(id) && (bevat(nieuw, id) || !meer || i < tot); }), r.h);
      werkLeegBij();
    }

    function gewijzigd(gid, nu, handle) {
      if (!root) return;
      var li = opRaster(gid);
      if (li) zet(li, nu);
      else if (nu && handle) { var h = {}; h[gid] = handle; delete geprobeerd[gid]; voegToe([gid], h); }
      if (!nu) rij = rij.filter(function (x) { return x !== gid; });
      werkLeegBij();
    }

    // bootVol: de stand is al volledig (verse Liquid-lezing toegepast). Anders wacht de pagina op de eerste
    // lezing of schrijfactie (of het mislukken ervan), zodat een verouderde opslag geen kaarten verbergt.
    function start(bootVol) {
      root = doc.querySelector('[data-hih-fav-pagina]');
      raster = root && root.querySelector('[data-hih-fav-raster]');
      if (!raster) { root = null; return; }
      leegEl = root.querySelector('[data-hih-fav-leeg]');
      foutEl = root.querySelector('[data-hih-fav-fout]');
      meer = root.querySelector('[data-hih-fav-meer]');
      bron = raster.getAttribute('data-bron');
      if (bron === 'browser') {
        rij = weergave(staat).slice();
        volgendBlok();
      } else {
        if (meer) { meer.addEventListener('click', laadMeer); kijkMeer(); }
        if (bootVol) { mag = true; volledig(); }
      }
      werkLeegBij();
    }

    return { start: start, gewijzigd: gewijzigd, volledig: function () { mag = true; volledig(); } };
  })();

  window.HihFavorieten = {
    ids: function () { return weergave(staat).slice(); },
    has: function (id) { var g = normalizeProductId(typeof id === 'number' ? id : String(id)); return !!g && bevat(weergave(staat), g); },
    toggle: toggle,
    refresh: refresh,
    count: function () { return weergave(staat).length; }
  };

  start();
})();
